import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Tooltip from './Tooltip';
import { REDUCER_NAME, fetchChartImage } from './reducer';
import './tooltipStyle.scss';
import Loading from '../../../common/loading/Loading';

const _format = require('string-format');
_format.extend(String.prototype, {});

class TooltipAlertSystem extends Component {
  componentDidMount() {
    const { fetchChartImage, organCode, id, images, theme } = this.props;
    if (!images || !Object.keys(images).length) {
      fetchChartImage(organCode, id, theme);
    }
  }

  renderHeaderTooltip = () => {
    const { title } = this.props;
    return (
      <div className="tooltip-header d-flex justify-content-center tooltip-header-alert">
        <span className="tooltip-header-alert-title text-uppercase">
          {title}
        </span>
      </div>
    );
  };
  render() {
    const {
      parent,
      isHovering,
      parentContent,
      images,
      isLoading,
      x,
    } = this.props;
    if (!isHovering) return null;

    return (
      <Tooltip
        parent={parent}
        parentContent={parentContent}
        active={isHovering}
        position={'leftBottom'}
        x={x}
        arrow={null}
        heightTooltip={239}
        widthTooltip={370}
      >
        <div className={`tooltip-ticker-hover tooltip-alert-system-hover`}>
          {this.renderHeaderTooltip()}
          <div className="tooltip-body">
            {isLoading ? (
              <Loading />
            ) : (
              <img
                className="alert-chart-image"
                alt="6 month chart"
                src={images}
              />
            )}
          </div>
        </div>
      </Tooltip>
    );
  }
}
const mapStateToProps = (state, props) => {
  return {
    images: state[REDUCER_NAME][props.id]
      ? state[REDUCER_NAME][props.id].images
      : '',
    isLoading: state[REDUCER_NAME][props.id]
      ? state[REDUCER_NAME][props.id].isLoading
      : false,
    i18n: state.i18n,
    theme: state.theme,
  };
};
TooltipAlertSystem.propTypes = {
  fetchChartImage: PropTypes.func.isRequired,
};
const mapDispatchToProps = {
  fetchChartImage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TooltipAlertSystem);
